"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const globalErrorCode_1 = require("../global/model/error/globalErrorCode");
const authError_1 = require("./model/error/authError");
const authErrorCode_1 = require("./model/error/authErrorCode");
class Auth {
    constructor(instance) {
        this.instance = instance;
    }
    signInWithIdentifierAndPasswordAsMerchant(identifier, password) {
        return new Promise((resolve, reject) => {
            const URL = '/merchant/auth';
            const lcIdentifier = identifier.toLowerCase();
            if (!lcIdentifier) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_IDENTIFIER));
                return;
            }
            if (!password) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD));
                return;
            }
            else if (password.length < 6) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD));
                return;
            }
            this.instance
                .post(URL, {
                identifier: lcIdentifier,
                password,
            }, {})
                .then((res) => {
                const auth = res.data;
                resolve(auth);
            })
                .catch((err) => {
                reject(this.handleError(err));
            });
        });
    }
    signInWithIdentifierAndPasswordAsUser(identifier, password) {
        return new Promise((resolve, reject) => {
            const URL = 'auth/local';
            const lcIdentifier = identifier.toLowerCase();
            if (!lcIdentifier) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_IDENTIFIER));
                return;
            }
            if (!password) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD));
                return;
            }
            else if (password.length < 6) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD));
                return;
            }
            this.instance
                .post(URL, {
                identifier: lcIdentifier,
                password,
            }, {})
                .then((res) => {
                const auth = res.data;
                resolve(auth);
            })
                .catch((err) => {
                reject(this.handleError(err));
            });
        });
    }
    signInWithGoogle(accessToken) {
        return new Promise((resolve, reject) => {
            const URL = 'auth/google/callback';
            this.instance
                .get(URL, {
                params: {
                    access_token: accessToken,
                },
            })
                .then((res) => {
                const auth = res.data;
                resolve(auth);
            })
                .catch((err) => {
                reject(this.handleError(err));
            });
        });
    }
    createMerchant(email, password, firstName, lastName, companyName, industry, goal, source = 9) {
        return new Promise((resolve, reject) => {
            const URL = '/merchant/register';
            const lcEmail = email.toLowerCase();
            if (!lcEmail) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_EMAIL));
            }
            if (!this.validateEmail_(lcEmail)) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_EMAIL));
            }
            if (!password) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD));
                return;
            }
            else if (password.length < 6) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD));
                return;
            }
            this.instance
                .post(URL, {
                email: lcEmail,
                password,
                firstname: firstName,
                lastname: lastName,
                'company_name': companyName,
                industry,
                goal,
                source,
            }, {})
                .then((res) => {
                const auth = res.data;
                resolve(auth);
            })
                .catch((err) => {
                reject(this.handleError(err));
            });
        });
    }
    createUser(username, email, password) {
        return new Promise((resolve, reject) => {
            const URL = '/auth/local/register';
            const lcEmail = email.toLowerCase();
            if (!username) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_USERNAME));
            }
            if (!lcEmail) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_EMAIL));
            }
            if (!this.validateEmail_(lcEmail)) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_EMAIL));
            }
            if (!password) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD));
                return;
            }
            else if (password.length < 6) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD));
                return;
            }
            this.instance
                .post(URL, {
                username,
                email: lcEmail,
                password,
            }, {})
                .then((res) => {
                const auth = res.data;
                resolve(auth);
            })
                .catch((err) => {
                reject(new authError_1.AuthError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.data.message));
            });
        });
    }
    forgotPassword(email, url) {
        return new Promise((resolve, reject) => {
            const URL = '/auth/forgot-password';
            const lcEmail = email.toLowerCase();
            if (!lcEmail) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_EMAIL));
            }
            if (!this.validateEmail_(lcEmail)) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_EMAIL));
            }
            if (!url) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_URL));
                return;
            }
            this.instance
                .post(URL, {
                email: lcEmail,
                url,
            }, {})
                .then((res) => {
                console.log(res.data);
                resolve(res.data.ok);
            })
                .catch((err) => {
                reject(this.handleError(err));
            });
        });
    }
    resetPassword(code, password, passwordConfirmation) {
        return new Promise((resolve, reject) => {
            const URL = '/auth/reset-password';
            if (!code) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_CODE));
            }
            if (!password) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD));
                return;
            }
            else if (password.length < 6) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD));
                return;
            }
            if (password !== passwordConfirmation) {
                reject(new authError_1.AuthError(authErrorCode_1.AuthErrorCode.INVALID_PASSWORD_CONFIRMATION));
            }
            this.instance
                .post(URL, {
                code,
                password,
                passwordConfirmation,
            }, {})
                .then((res) => {
                const auth = res.data;
                resolve(auth);
            })
                .catch((err) => {
                reject(new authError_1.AuthError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, err.response.data.message));
            });
        });
    }
    validateEmail_(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
    handleError(error) {
        if (error.response.data.message === 'Identifier or password invalid.') {
            return new authError_1.AuthError(authErrorCode_1.AuthErrorCode.USER_NOT_FOUND);
        }
        else if (error.response.data.message === 'Email is already taken.') {
            return new authError_1.AuthError(authErrorCode_1.AuthErrorCode.EMAIL_IS_TAKEN, error.response.data.message);
        }
        else if (error.response.data.message ===
            'Your email account is not confirmed yet.') {
            return new authError_1.AuthError(authErrorCode_1.AuthErrorCode.EMAIL_UNCONFIRMED, error.response.data.message);
        }
        else if (error.response.data.message === 'This email does not exist.') {
            return new authError_1.AuthError(authErrorCode_1.AuthErrorCode.EMAIL_NOT_EXIST, error.response.data.message);
        }
        else if (error.response.data.message === 'You are not a merchant.') {
            return new authError_1.AuthError(authErrorCode_1.AuthErrorCode.NOT_MERCHANT, error.response.data.message);
        }
        else {
            return new authError_1.AuthError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.message);
        }
    }
}
exports.Auth = Auth;
//# sourceMappingURL=auth.js.map